export enum ComplexStatus {
  ARCHIVED = 'ARCHIVED',
  SETUP = 'SETUP',
  RESTRICTED = 'RESTRICTED',
  ACTIVE = 'ACTIVE'
}

export const ComplexStatusColor = {
  [ComplexStatus.ACTIVE]: '#1D8F0B',
  [ComplexStatus.RESTRICTED]: '#1373E6',
  [ComplexStatus.SETUP]: '#FF8C1A',
  [ComplexStatus.ARCHIVED]: '#DFDFDF',
};

export enum ComplexStatusState {
  DEFAULT = 'default',
  HOVERED = 'hovered',
  STABLE = 'stable',
}

export enum ComplexStatusRoundingDirection {
  LEFT = 'left',
  RIGHT = 'right',
}
